import React, { useState } from "react";

function orderMarkets(markets) {
  const marketNamesInOrder = ["EURONEXT", "CBOT", "BÉT"];

  markets.forEach(function (market) {
    const index = marketNamesInOrder.findIndex((name) => name === market.name);

    marketNamesInOrder[index] = market;
  });

  return marketNamesInOrder;
}

const styles = {
  marketList: {
    display: "flex",
    alignItems: "center",
    listStyle: "none",
    paddingLeft: 0,
  },

  marketListItemSelected: {
    backgroundColor: "#496587",
    color: "white",
  },

  button: {
    background: "none",
    border: 0,
    cursor: "pointer",
    height: 24,
    margin: "8px 5px",
    backgroundColor: "white",
    border: "1px solid #496587",
    borderRadius: 5,
    color: "#496587",
    fontSize: 13,
    fontWeight: "bold",
    lineHeight: "16px",
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 3,
  },
};

const MarketList = ({ markets, getMarket }) => {
  const [selectedMarket, setSelectedMarket] = useState("EURONEXT");
  const orderedMarkets = orderMarkets(markets);

  return (
    <ul style={styles.marketList}>
      {orderedMarkets.map((market, index) => {
        const isSelectedStyle =
          market.name === selectedMarket ? styles.marketListItemSelected : {};

        return (
          <li style={{ ...styles.marketListItem }} key={index}>
            <button
              type="button"
              style={{ ...styles.button, ...isSelectedStyle }}
              onClick={() => {
                setSelectedMarket(market.name);
                getMarket(market.name);
              }}
            >
              {market.name}
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default MarketList;
